export default "__VITE_ASSET__oGrzxNF4__"